export type EntryActionId = 'novel' | 'audio' | 'research' | 'new-short' | 'new-film' | 'resume' | 'advanced' | 'review';

export interface EntryAction {
  id: EntryActionId;
  label: string;
  description: string;
  tone: 'primary' | 'secondary' | 'quiet';
  enabled: boolean;
  reason?: string;
}

export function entryActions(authenticated: boolean, hasDraft: boolean): EntryAction[] {
  return [
    {
      id: 'novel', label: '剧本改编 · 织梦', tone: 'primary', enabled: true,
      description: '读取完整原著，比较场面试写，再调整人物与全剧。',
    },
    {
      id: 'new-short', label: '新建竖屏短剧', tone: 'secondary', enabled: true,
      description: '从创作简报开始，逐步完成人物、装置、单集和场景。',
    },
    {
      id: 'new-film', label: '电影剧本 · 进阶', tone: 'secondary', enabled: true,
      description: '保留长片的幕、序列和人物弧能力。',
    },
    {
      id: 'resume', label: '继续当前项目', tone: 'secondary', enabled: hasDraft,
      description: '返回最近编辑的故事与生成进度。',
      reason: hasDraft ? undefined : '当前还没有可继续的工作区草稿。',
    },
    {
      id: 'advanced', label: '高级画布', tone: 'quiet', enabled: true,
      description: '直接编辑节点、连接和结构关系。',
    },
    {
      id: 'review', label: 'SceneWeave · GitHub', tone: 'quiet', enabled: true,
      description: '查看 SceneWeave 的开源代码、研究说明与评估材料。',
    },
  ];
}

export function isAdaptationEntry(search: string): boolean {
  return new URLSearchParams(search).get('entry') === 'adaptation';
}
